export const NoContentTexts = {
  noContentDataForPeriod:
    'Não há informações de rentabilidade da sua carteira referente ao período selecionado',
  noContentDataAtAll:
    'Ainda não existem dados de rentabilidade. Ao investir o tempo de atualização será de até 2 dias úteis'
};
